var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
export var CLAN_PERMISSION_BOOLEAN_KEYS = [
    "admin",
    "createClanSearchFilter",
    "readClanSearchFilter",
    "updateClanSearchFilter",
    "deleteClanSearchFilter",
    "createClanApiSearchFilter",
    "readClanApiSearchFilter",
    "updateClanApiSearchFilter",
    "deleteClanApiSearchFilter",
    "createClanPersonalSearchFilter",
    "readClanPersonalSearchFilter",
    "updateClanPersonalSearchFilter",
    "deleteClanPersonalSearchFilter",
    "createPlayersOnClan",
    "deletePlayersOnClan",
    "readClanPermissions",
    "updateClanPermissions",
    "readMatchs",
    "updateMatchDecisions",
    "readClanConfig",
    "updateClanConfig",
];
export var createEmptyClanEffectivePermissions = function () { return ({
    canAccessClan: false,
    admin: false,
    createClanSearchFilter: false,
    readClanSearchFilter: false,
    updateClanSearchFilter: false,
    deleteClanSearchFilter: false,
    createClanApiSearchFilter: false,
    readClanApiSearchFilter: false,
    updateClanApiSearchFilter: false,
    deleteClanApiSearchFilter: false,
    createClanPersonalSearchFilter: false,
    readClanPersonalSearchFilter: false,
    updateClanPersonalSearchFilter: false,
    deleteClanPersonalSearchFilter: false,
    createPlayersOnClan: false,
    deletePlayersOnClan: false,
    readClanPermissions: false,
    updateClanPermissions: false,
    readMatchs: false,
    updateMatchDecisions: false,
    readClanConfig: false,
    updateClanConfig: false,
}); };
export var createFullClanEffectivePermissions = function () {
    var e_1, _a;
    var permissions = createEmptyClanEffectivePermissions();
    permissions.canAccessClan = true;
    try {
        for (var CLAN_PERMISSION_BOOLEAN_KEYS_1 = __values(CLAN_PERMISSION_BOOLEAN_KEYS), CLAN_PERMISSION_BOOLEAN_KEYS_1_1 = CLAN_PERMISSION_BOOLEAN_KEYS_1.next(); !CLAN_PERMISSION_BOOLEAN_KEYS_1_1.done; CLAN_PERMISSION_BOOLEAN_KEYS_1_1 = CLAN_PERMISSION_BOOLEAN_KEYS_1.next()) {
            var key = CLAN_PERMISSION_BOOLEAN_KEYS_1_1.value;
            permissions[key] = true;
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (CLAN_PERMISSION_BOOLEAN_KEYS_1_1 && !CLAN_PERMISSION_BOOLEAN_KEYS_1_1.done && (_a = CLAN_PERMISSION_BOOLEAN_KEYS_1.return)) _a.call(CLAN_PERMISSION_BOOLEAN_KEYS_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return permissions;
};
